import { css } from "@emotion/css";
import { ReactNode } from "react";
import { RaceData } from "./types";
import { TURQUOISE } from "./colors";

const styles = {
  container: `
    margin-top: 30px;
    text-wrap: wrap;
    text-align: center;
    color: ${TURQUOISE.brighten(1.6).hex()};
    line-height: 42px;
  `,
  number: `
    font-size: 48px;
    font-weight: 200;
  `,
  bold: `
    font-weight: 700;
  `,
  and: `
    font-size: 24px;
    font-weight: 300;
  `,
  error: `
    font-size: 16px;
    color: red;
    line-height: 18px;
  `,
};

const pluralizeNodesWithBoldIndex = (
  vals: string[],
  boldIdx: number,
): ReactNode => {
  switch (vals.length) {
    case 0:
      return null;
    case 1:
      return (
        <span className={css(styles.number, styles.bold)}>
          {vals[0]}
        </span>
      );
    case 2:
      return (
        <>
          <span
            className={css(
              `${styles.number}${boldIdx === 0 ? styles.bold : ""}`,
            )}
          >
            {vals[0]}
          </span>
          <span className={css(styles.and)}> and </span>
          <span
            className={css(
              `${styles.number}${boldIdx === 1 ? styles.bold : ""}`,
            )}
          >
            {vals[1]}
          </span>
        </>
      );
    default:
      return (
        <>
          {vals
            .slice(0, vals.length - 1)
            .map((val, idx) => (
              <>
                <span
                  className={css(
                    `${styles.number}${boldIdx === idx ? styles.bold : ""}`,
                  )}
                >
                  {val}
                </span>
                <span className={css(styles.number)}>
                  ,{" "}
                </span>
              </>
            ))}
          <span className={css(styles.and)}>and </span>
          <span
            className={css(
              `${styles.number}${boldIdx === vals.length - 1 ? styles.bold : ""}`,
            )}
          >
            {vals[vals.length - 1]}
          </span>
        </>
      );
  }
};

export const Results = ({
  raceData,
}: {
  raceData: RaceData;
}) => {
  return (
    <div className={css(styles.container)}>
      {pluralizeNodesWithBoldIndex(
        raceData.pointLaps.map((lapNumber) =>
          lapNumber.toString(),
        ),
        raceData.bonusIdx,
      )}
      {raceData.missingSprints && (
        <div className={css(styles.error)}>
          Wow, you're unlucky. The odds of seeing this
          message are on the order of winning the lottery
          several drawings in a row, but somehow, here we
          are. Practically, what this means for you is that
          you get fewer sprints than you asked for. If
          that's not ok with you, you should try again with
          a different seed.
        </div>
      )}
    </div>
  );
};
